import parcelPickupRenderOpeningTimes from './parcelPickupRenderOpeningTimes';

export default (location) => {
  const distance = location.distance < 1000
    ? `${location.distance} m`
    : `${Math.round(location.distance / 1000)} km`;

  const openingTimes = typeof location.opening_hours !== 'undefined'
    ? parcelPickupRenderOpeningTimes(location.opening_hours)
    : '';

  return `
    <div class="parcel-pickup__row">
      <button
        type="button"
        class="parcel-pickup__item"
        data-company-name="${location.location} ${location.street}"
        data-information='${JSON.stringify(location)}'
        data-action="click->parcel-pickup#selectLocation"
      >
        <div class="parcel-pickup__distance">
          ${distance}
        </div>

        <div class="parcel-pickup__location">
          ${location.location} ${location.street}
        </div>
      </button>

      <div class="parcel-pickup__dropdown">
        <div class="row">
          <div class="col-sm-6">
            <strong class="d-block">Adres</strong>

            <div class="mt-1">
              ${location.street} ${location.number}<br>
              ${location.postal_code} ${location.city}
            </div>
          </div>

          <div class="col-sm-6 mt-3 mt-sm-0">
            ${openingTimes}
          </div>
        </div>
      </div>
    </div>
  `;
};
